{
  "fr": {
    "activity": {
      "attributes": {
        "end": "Début",
        "now": "Présent",
        "title": "Activités"
      },
      "labels": {
        "no_activities": "Aucune activité pour le moment",
        "no_activities_subtitle": "Lorsqu'une personne publie une nouvelle annonce, décision, question, etc., vous la verrez ici.",
        "not_opened_yet": "Pas encore vu"
      },
      "projects": {
        "announcement": {
          "create": "a crée une actualité."
        },
        "building": {
          "create": "a créé bâtiment <i>{notifiable_name}</i>"
        },
        "document": {
          "create": "a téléchargé le document <i>'{notifiable_name}'</i>."
        },
        "lot": {
          "create": "a créé lot <i>{notifiable_name}</i>."
        },
        "phase": {
          "create": "a créé phase <i>{notifiable_name}</i>."
        },
        "published": {
          "customer": "a publié la décision <i>'{notifiable_name}'</i> pour le client.",
          "partners": "a publié la décision <i>'{notifiable_name}'</i> pour les fournisseur(s)."
        },
        "question": {
          "create": "a crée la question <i>'{notifiable_name}'</i> dans FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "create": "a créé l'espace: <i>{notifiable_name}</i>.",
          "update": "a assigné l'espace {notifiable_name} à une unité."
        },
        "survey_type": {
          "create": "a creé une formulaire <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "a commencé la conversation <i>'{notifiable_name}'</i>."
        },
        "unit": {
          "assign": "a assigné un client à unité <i>'{notifiable_name}'</i>.",
          "create": "a créé unité <i>{notifiable_name}</i>.",
          "invisibled": "a révoqué l'accès cient pour l'unité <i>'{notifiable_name}'</i>.",
          "unassign": "a supprimé le client de l'unité <i>'{notifiable_name}'</i>.",
          "visibled": "a donné accès au client pour l'unité <i>'{notifiable_name}'</i>."
        }
      },
      "units": {
        "announcement": {
          "create": "a crée une actualité."
        },
        "decision": {
          "create": "a crée la décision <i>'{notifiable_name}'</i>.",
          "not_interested": "n'est pas intéressé par la décision <i>'{notifiable_name}'</i>.",
          "published": {
            "customer": "a publié la décision <i>'{notifiable_name}'</i> pour le client.",
            "partners": "a publié la décision <i>'{notifiable_name}'</i> pour les fournisseur(s)."
          },
          "relaunched": "rendu la décision <i>'{notifiable_name}'</i> à nouveau disponible."
        },
        "decision_document": {
          "create": "a téléchargé le document <i>'{notifiable_name}'</i> pour décision <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "a accepté propostion <i>'{notifiable_name}'</i> pour la décision <i>'{group_name}'</i>.",
          "create": {
            "customer": "a partagé proposition <i>'{notifiable_name}'</i> avec le client.",
            "employee": "a crée proposition <i>'{notifiable_name}'</i>.",
            "partnergroup": "a partagé proposition <i>'{notifiable_name}'</i> avec les fournisseur(s) <i>{target_name}</i>."
          },
          "unapproved": "proposition non approuvée <i>'{notifiable_name}'</i> dans la décision <i>'{group_name}'</i>.",
          "updated": "proposition mise à jour <i>'{notifiable_name}'</i> dans la décision <i>'{group_name}'</i>."
        },
        "document": {
          "create": "a téléchargé le document <i>'{notifiable_name}'</i>."
        },
        "issue": {
          "approval": {
            "create": "a demandé l'approbation du client.",
            "delete": "a supprimé la demande d'approbation du client.",
            "rejected": "a rejeté ce point."
          },
          "approved": "a approuvé ce point",
          "create": "a créé ce point",
          "status": {
            "update": "a modifié l'état du point <i>'{notifiable_name}'</i> en <i>{target_name}</i>."
          }
        },
        "proposal": {
          "deleted": "proposition supprimée <i>'{notifiable_name}'</i>."
        },
        "question": {
          "create": "a crée la question <i>'{notifiable_name}'</i> dans FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "update": "a assigné l'espace {notifiable_name} à une unité."
        },
        "survey": {
          "create": "a crée une formulaire <i>'{notifiable_name}'</i>.",
          "published": "a publié une formulaire<i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "a commencé la conversation <i>'{notifiable_name}'</i>.",
          "message": {
            "move": "a déplacé un message vers la conversation <i>'{notifiable_name}'</i>."
          }
        },
        "unit": {
          "assign": "a assigné un client à unité <i>'{notifiable_name}'</i>.",
          "invisibled": "a révoqué l'accès cient pour l'unité <i>'{notifiable_name}'</i>.",
          "unassign": "a supprimé le client de l'unité <i>'{notifiable_name}'</i>.",
          "visibled": "a donné accès au client pour l'unité <i>'{notifiable_name}'</i>."
        }
      }
    }
  }
}